import React from 'react'
import classes from './GoButton.module.css'
import { Link } from 'react-router-dom'


const GoButton = () => {
    return (

        <Link className={classes.button} to='/app'>Go!</Link>

    )
}

export default GoButton